// extracted by mini-css-extract-plugin
export default {"idMeBox":"IdMeToggle-module_idMeBox_MdEjFHeFXl","checkoutIdMeBox":"IdMeToggle-module_checkoutIdMeBox_X_1UZ0eD7O","dropDownBorder":"IdMeToggle-module_dropDownBorder_XKgyI8ELO0"};